import type { Connection } from '../../../types';
import type { ScopeContext } from '../../../contexts/ScopeContext';

interface ConnectionHeaderProps {
  connection: Connection;
  scope: ScopeContext;
}

export function ConnectionHeader({ connection, scope }: ConnectionHeaderProps) {
  return (
    <>
      {/* Breadcrumb */}
      <div className="text-sm breadcrumbs mb-4">
        <ul>
          <li><a href={`${scope.getNavigationPrefix()}/connections`}>Connections</a></li>
          <li>{connection?.connectionId}</li>
        </ul>
      </div>

      {/* Connection Header */}
      <div className="card bg-base-100 shadow-xl mb-6">
        <div className="card-body">
          <div>
            <h1 className="card-title text-2xl">{connection?.connectorId}</h1>
            <p className="text-sm opacity-70">{connection?.connectionId}</p>
            {connection?.metadata?.description && (
              <p className="mt-2">{connection?.metadata?.description}</p>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
